/// <amd-module name="ReportsCommon/DonutChartVisual/Components/DonutChartLegend" />
import * as React from "react";
import { css } from "VSSUI/Util";


export interface IDonutChartLegend {
    count: number | string;
    label: string;
    color: string;
    sublabel?: string;
}

export interface IDonutChartLegendProps {
    className?: string;
    legend: IDonutChartLegend[];
    diameter?: number;
}

export class DonutChartLegendComponent extends React.PureComponent<IDonutChartLegendProps, {}> {
    public render(): JSX.Element {
        const dataCounts: JSX.Element[] = [];
        const dataColors: JSX.Element[] = [];
        const dataLabels: JSX.Element[] = [];

        this.props.legend.forEach(l => {
            dataCounts.push(
                <div key={l.label} className="legend-cell data-count">
                    {l.count}
                </div>
            );
            dataColors.push(
                <div key={l.label} title={l.label} className="legend-cell data-color">
                    {this._getLegendCircleElement(l.color)}
                </div>
            );
            dataLabels.push(
                <div key={l.label} className="legend-cell data-value text-ellipsis">
                    {l.label}
                </div>
            );

            if (!!l.sublabel) {
                dataCounts.push(<div key={l.sublabel} className="legend-sub-cell data-count" />);
                dataColors.push(<div key={l.sublabel} title={l.sublabel} className="legend-sub-cell data-color" />);
                dataLabels.push(
                    <div key={l.sublabel} className="legend-sub-cell data-value text-ellipsis">
                        {l.sublabel}
                    </div>
                );
            }
        });
        return (
            <div className={css("donut-legend-container", "flex", this.props.className || "")}>
                <div>{dataCounts}</div>
                <div>{dataColors}</div>
                <div className="legend-labels">{dataLabels}</div>
            </div>
        );
    }

    private _getLegendCircleElement(color: string): JSX.Element {

        const diameterValue = !!this.props.diameter ? this.props.diameter : this._defaultCircleDiameter;
        const radius = diameterValue / 2;

        const diameterStr = diameterValue + "px";       

        const legendCircle: JSX.Element = (
            <span className="legend-circle">
                <svg width={diameterStr} height={diameterStr}>
                    <circle className="color-circle" cx={radius} cy={radius} r={radius} fill={color} />
                </svg>
            </span>
        );

        return legendCircle;
    }

    private readonly _defaultCircleDiameter: number = 14;
}
